import { formatList } from "web/services/format"

export function formStateFromTask({
  category,
  approval_requests,
  assignees,
  completion_notification_business_roles,
  ...restOfTask
}) {
  const value = { ...restOfTask }

  if (assignees) {
    value.assignees = assignees.map((assignee) => assignee.assignee_id)
  }

  if (approval_requests) {
    value.approval_requests = approval_requests.map(
      (approval_request) => approval_request.business_role_id
    )
  }

  if (category) {
    value.category_id = category.id
  }

  if (completion_notification_business_roles) {
    value.completion_notification_business_roles =
      completion_notification_business_roles.map(
        (cnbr) => cnbr.business_role_id
      )
  }

  return value
}

export const UNCATEGORIZED_CATEGORY_NAME = "Uncategorized"

function reorderElements(items, prevPos, newPos) {
  const [element] = items.splice(prevPos, 1)
  items.splice(newPos, 0, element)

  const reorderedItems = items.map((obj, index) => ({
    ...obj,
    ordinal: index + 1,
  }))
  return reorderedItems
}

export function reorderTasks({ categories, items, from, to }) {
  const reorderedTasks = reorderElements(items, from, to)
  const categoryId = items[from]?.category?.id
  const categoryIndex = categories.findIndex(
    (category) =>
      category.id === categoryId ||
      category.name === UNCATEGORIZED_CATEGORY_NAME
  )
  const categoryData = categories[categoryIndex]
  const updatedData = { ...categoryData, tasks: reorderedTasks }

  categories.splice(categoryIndex, 1, updatedData)
  categories.updateLocal(categories)

  const offsetFrom = from + 1
  const offsetTo = to + 1

  categories.reorderTasks({
    taskId: items[from].id,
    from: offsetFrom,
    to: offsetTo,
  })
}

export function formatListOfUsers(users, currentUser) {
  if (!users) {
    return null
  }

  const userNames = users.map((u) =>
    u.id === currentUser.id ? "you" : u.full_name
  )

  if (userNames.length >= 3) {
    const othersLabel = `${userNames.length - 2} other${
      userNames.length > 3 ? "s" : ""
    }`

    return formatList(userNames.slice(0, 2).concat(othersLabel))
  } else {
    return formatList(userNames)
  }
}
